import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "position-absolute start-50 top-50",
  style: {"z-index":"5"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute top-0 start-0 end-0 bottom-0 bg-body",
  style: {"z-index":"4","opacity":"0.5"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "loader", {}, () => [
            _createVNode(_component_Spinner)
          ])
        ]),
        _hoisted_3
      ]))
    : _createCommentVNode("", true)
}